export default "/images/icon_bg_button.svg?7c68bcea30139ab55b5ebebef064b88e";